import { useEffect, useState } from "react";
import { api, fmtMoney, fmtDate } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import EmptyState from "@/components/common/EmptyState";
import { ArrowDownToLine } from "lucide-react";

export default function PaymentsReceived() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => { api.get("/payments-received").then(({ data }) => { setItems(data); setLoading(false); }); }, []);

    return (
        <>
            <PageHeader kicker="SALES" title="Payments Received" subtitle="Settled customer payments with allocations and bank impact." />
            <PageBody>
                <div className="bg-card border border-border rounded-md overflow-hidden">
                    {loading ? <div className="p-8 text-muted-foreground text-center">Loading…</div> :
                        items.length === 0 ? <EmptyState icon={ArrowDownToLine} title="No payments yet" description="Receipts you record against invoices will appear here." /> :
                            <table className="fin-table">
                                <thead><tr><th>Receipt</th><th>Customer</th><th>Date</th><th>Method</th><th className="num">Amount</th><th className="num">Unapplied</th></tr></thead>
                                <tbody>
                                    {items.map((p) => (
                                        <tr key={p.id} data-testid={`payment-recv-${p.id}`}>
                                            <td className="font-mono text-[12.5px]">{p.number}</td>
                                            <td>{p.party_name}</td>
                                            <td className="text-[12px] text-muted-foreground">{fmtDate(p.date)}</td>
                                            <td className="text-[12px]">{p.method}</td>
                                            <td className="num">{fmtMoney(p.amount, p.currency)}</td>
                                            <td className="num">{fmtMoney(p.unapplied || 0, p.currency)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>}
                </div>
            </PageBody>
        </>
    );
}
